import React, { useState, useEffect } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import { newFetch, GET } from '../../../../helpers/fetch';
import SpringLoader from '../../../../components/SpringLoader/SpringLoader.js';

const Collection = () => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const history = useHistory();
  const [collections, setCollections] = useState([]);
  const [filterResults, setFilterResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);

  const checkHandler = (e, value) => {
    if (filterResults.length == 0) {
      setFilterResult([value]);
    } else {
      filterResults.map((item) => {
        if (!filterResults.includes(value)) {
          setFilterResult([value].concat(filterResults));
        } else {
          let index = filterResults.indexOf(value);
          let newArray = filterResults.filter(
            (condition) => condition != value
          );
          setFilterResult(newArray);
        }
      });
    }
  };

  const resetFilter = () => {
    setFilterResult([]);
  };

  const fetchCollections = async (filterResults) => {
    setLoading(true); // Start the loader
    try {
      const api_path = `/reward/cart/client/${clientID}/site/${siteID}`;
      const response = await newFetch(GET, api_path);

      if (response.success) {
        if (filterResults.length === 0) {
          setCollections(response.data);
        } else {
          const filteredData = response.data.filter((item) => {
            if (filterResults.includes('collected') && item.is_collected === 1)
              return true;
            if (filterResults.includes('cancelled') && item.is_collected === 3)
              return true;
            if (filterResults.includes('mailed') && item.is_mailed) return true;
            if (
              filterResults.includes('pendingCollection') &&
              item.is_collected === 0 &&
              !item.is_mailed
            )
              return true;
            return false;
          });
          setCollections(filteredData);
        }
      } else {
        setCollections([]); // Handle no data gracefully
      }
    } catch (error) {
      console.error('Error fetching collections:', error);
      setCollections([]); // Handle error gracefully
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  React.useEffect(() => {
    fetchClients();
  }, [clientID]);

  useEffect(() => {
    fetchCollections(filterResults);
  }, [filterResults]);

  useEffect(() => {
    fetchCollections(filterResults);
  }, [clientID, siteID]);

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Rewards Collection Management
        </h6>
      </div>
      {clients.enable_reward ? (
        <>
          <div className="d-flex flex-row align-items-center py-3">
            <h6 className="flex-grow-1">Associate </h6>

            <div className="dropdown custom-dropdown">
              <button
                className="btn btn-brand ms-3 dropdown-toggle adjust-fs adjust-shadow"
                style={{ width: '100px' }}
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  className="fas fa-plus"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></i>{' '}
                Filter
              </button>
              <div
                className="dropdown-menu dropdown-menu-right mt-2"
                style={{ width: '300px' }}
                aria-labelledby="dropdownMenuButton"
              >
                <div className="container">
                  <React.Fragment>
                    <div className="d-flex flex-column pb-2 pt-2">
                      <div className="container">
                        <div className="d-flex">
                          <label style={{ cursor: 'pointer' }}>
                            <input
                              type="checkbox"
                              value=" Collected"
                              className="me-2"
                              onChange={(e) => checkHandler(e, 'collected')}
                            />
                            <strong className="text-muted">Collected</strong>
                          </label>
                        </div>
                        <div className="d-flex">
                          <label style={{ cursor: 'pointer' }}>
                            <input
                              type="checkbox"
                              value=" cancelled"
                              className="me-2"
                              onChange={(e) => checkHandler(e, 'cancelled')}
                            />
                            <strong className="text-muted">Cancelled</strong>
                          </label>
                        </div>
                        <div className="d-flex">
                          <label style={{ cursor: 'pointer' }}>
                            <input
                              type="checkbox"
                              value=" Mailed"
                              className="me-2"
                              onChange={(e) => checkHandler(e, 'mailed')}
                            />
                            <strong className="text-muted">Mailed</strong>
                          </label>
                        </div>

                        <div className="d-flex">
                          <label style={{ cursor: 'pointer' }}>
                            <input
                              type="checkbox"
                              value=" pendingCollection"
                              className="me-2"
                              onChange={(e) =>
                                checkHandler(e, 'pendingCollection')
                              }
                            />
                            <strong className="text-muted">
                              Pending Collection
                            </strong>
                          </label>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                  <div className="d-flex justify-content-end border-top py-2">
                    <div
                      className="text-muted fw-bold"
                      onClick={resetFilter}
                      style={{ cursor: 'pointer' }}
                    >
                      Clear
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="springloader-holder">
              <SpringLoader />
            </div>
          ) : (
            <div className="mt-4">
              <div className="table-responsive rounded shadow bg-white">
                <table className="table table-borderless mb-0">
                  <thead className="border-bottom">
                    <tr>
                      <th className="py-3 text-muted fw-normal px-3">ID</th>
                      <th className="py-3 text-muted fw-normal">Associate</th>
                      <th className="py-3 text-muted fw-normal">Client</th>
                      <th className="py-3 text-muted fw-normal">
                        Items (Quantity)
                      </th>
                      <th className="py-3 text-muted fw-normal">Redeem Date</th>
                      <th className="py-3 text-muted fw-normal">
                        Collection Option
                      </th>
                      <th className="py-3 text-muted fw-normal">Status</th>
                      <th className="py-3 text-muted fw-normal text-center px-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {collections.length > 0 ? (
                      collections.map((collection, index) => (
                        <tr key={index} className="border-bottom">
                          <td
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                            className="px-3 text-muted"
                          >
                            {collection.id.toString().padStart(8, 0)}
                          </td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >{`${
                            collection.associate !== null
                              ? collection.associate.first_name
                              : 'No First Name'
                          } ${
                            collection.associate !== null
                              ? collection.associate.last_name
                              : 'No Last Name'
                          }`}</td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >
                            {collection.associate !== null
                              ? collection.associate.site_associates.map(
                                  (item, index) => item.site.client.name
                                )
                              : ''}
                          </td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >
                            {collection.items.length > 0 &&
                              collection.items.map((item, index) => (
                                <div
                                  key={index}
                                  className="d-flex justify-content-between align-items-center"
                                >
                                  <div className="d-flex flex-column flex-grow-1">
                                    <div
                                      className="p-0 m-0"
                                      style={{ fontSize: '0.9rem' }}
                                    >
                                      {item &&
                                        _.truncate(item.reward_item.name, {
                                          length: 24,
                                        })}{' '}
                                      <span className="text-muted">
                                        (x{item && item.quantity})
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >
                            {moment(collection.createdAt).format(
                              // 'D/M/YYYY hh:mm:ssa'
                              'D/M/YYYY'
                            )}
                          </td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >
                            {collection.is_mailing ? 'Mailing' : 'Self Collect'}
                          </td>
                          <td
                            className="text-muted"
                            style={{
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              history.push(
                                `/rewards/collection/${collection.id}`
                              )
                            }
                          >
                            <span
                              className={`badge rounded-pill p-2 ${
                                !collection.is_collected &&
                                !collection.is_mailing
                                  ? 'text-bg-warning'
                                  : !collection.is_mailed &&
                                    collection.is_mailing
                                  ? 'text-bg-warning'
                                  : collection.is_mailed &&
                                    collection.is_mailing
                                  ? 'text-bg-success'
                                  : collection.is_collected == 1
                                  ? 'text-bg-success'
                                  : collection.is_collected == 3
                                  ? 'text-bg-danger'
                                  : 'text-bg-warning'
                              }`}
                            >
                              {!collection.is_collected &&
                              !collection.is_mailing
                                ? 'Pending Collection'
                                : !collection.is_mailed && collection.is_mailing
                                ? 'Pending Mailing'
                                : collection.is_mailed && collection.is_mailing
                                ? 'Mailed'
                                : collection.is_collected == 1
                                ? 'Collected'
                                : collection.is_collected == 3
                                ? 'Cancelled'
                                : ''}
                            </span>
                          </td>
                          <td
                            className="text-center align-items-center px-3"
                            style={{ verticalAlign: 'middle' }}
                          >
                            <div
                              style={{ cursor: 'pointer' }}
                              className="dropdown custom-dropdown"
                            >
                              <button
                                className="btn dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i
                                  className="fas fa-ellipsis-h adjust-fs"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                ></i>
                              </button>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{ width: '150px' }}
                              >
                                <Link
                                  to={`/rewards/collection/${collection.id}`}
                                  style={{ cursor: 'pointer' }}
                                  className="dropdown-item adjust-fs"
                                >
                                  Collection detail
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          No collections found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default Collection;
